<template>
  <div class="order-head">
    <div class="order-head-row" :class="{ 'is-readonly': readonly }" @click="goedit">
      <!-- 只读（订单详情等）：图标在左、与文案成组，避免去掉箭头后右侧留白失衡（行业常见：地标前缀） -->
      <div v-if="readonly" class="order-head-leading" aria-hidden="true">
        <img class="order-head-pin order-head-pin--leading" src="../../assets/images/dizhi.svg" alt="" />
      </div>
      <div class="order-head-main">
        <div class="order-head-name-row">
          <span class="order-head-name">{{ displayName }}</span>
          <span v-if="displayTel" class="order-head-tel">{{ getPhone(displayTel) }}</span>
        </div>
        <div class="order-head-address">{{ displayAddress }}</div>
      </div>
      <!-- 可点（结算等）：右侧 地标 + 箭头，暗示整条可进入地址页 -->
      <div v-if="!readonly" class="order-head-side">
        <img class="order-head-pin" src="../../assets/images/dizhi.svg" alt="" />
        <van-icon class="order-head-arrow" name="arrow" color="#999" />
      </div>
    </div>
    <div class="order-head-ribbon">
      <img src="../../assets/images/caitiao.svg" alt="" class="cai" />
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderHead",
  props: {
    name: {
      type: String,
    },
    tel: {
      type: String,
    },
    address: {
      type: [String, null],
      default: null,
    },
    /** 旧页 ToOrder：整单地址对象（含 province/city/county/addressDetail/recipient 等） */
    data1: {
      type: [Object, String],
      default: null,
    },
    /** 订单详情待支付等场景：仅展示，不可跳转改址 */
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayName() {
      if (this.name) return this.name;
      if (this.data1 && typeof this.data1 === "object") {
        return this.data1.recipient || this.data1.recipientName || "";
      }
      return "";
    },
    displayTel() {
      if (this.tel) return this.tel;
      if (this.data1 && typeof this.data1 === "object") {
        return this.data1.recipientMobile || this.data1.mobile || "";
      }
      return "";
    },
    displayAddress() {
      if (this.address) return this.address;
      if (this.data1 && typeof this.data1 === "object") {
        const d = this.data1;
        const line =
          (d.province || "") +
          (d.city || "") +
          (d.county || "") +
          (d.addressDetail || d.address || "");
        const house = d.houseNum || "";
        return line + house;
      }
      return "";
    },
  },
  methods: {
    getPhone(phone) {
      return this.$utils.formPhone(phone);
    },
    goedit() {
      if (this.readonly) return;
      this.$emit("EditAddress");
    },
  },
};
</script>

<style lang="scss" scoped>
/* 上：姓名区顶 / 下：彩条底 留白一致；地址与彩条之间单独留一段 */
.order-head {
  --order-head-edge-gap: 0.5rem;
  --order-head-ribbon-gap: 0.45rem;
}

.order-head-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding-top: var(--order-head-edge-gap);
  padding-bottom: var(--order-head-ribbon-gap);

  &.is-readonly {
    cursor: default;
    justify-content: flex-start;
  }
}

.order-head-leading {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  padding-top: 3px;
  margin-left: 0.75rem;
  margin-right: 0.4rem;
}

.order-head-ribbon {
  margin: 0;
  padding-bottom: var(--order-head-edge-gap);
  line-height: 0;
  font-size: 0;
}

.order-head-main {
  margin-left: 1.1rem;
  flex: 1 1 auto;
  min-width: 0;
}

.order-head-row.is-readonly .order-head-main {
  margin-left: 0;
  padding-right: 0.75rem;
}

.order-head-pin--leading {
  margin-top: 0;
}

.order-head-name-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0 0.5rem;
}

.order-head-name,
.order-head-tel {
  font-size: 0.95rem;
  font-weight: 600;
  color: #333;
  line-height: 1.35;
}

.order-head-address {
  font-size: 0.8125rem;
  color: #464646;
  line-height: 1.35;
  margin-top: 0.28rem;
  word-break: break-word;
}

.order-head-side {
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
  padding-top: 2px;
}

.order-head-pin {
  width: 16px;
  height: 16px;
  object-fit: contain;
  margin-top: 1px;
}

.order-head-arrow {
  margin-left: 0.5rem;
  margin-right: 1.1rem;
  font-size: 14px;
  line-height: 1;
}

.cai {
  width: 100%;
  display: block;
  vertical-align: top;
}
</style>
